import { mapActions, mapGetters, mapMutations } from "vuex";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";
import deliveryNovaPoshta from "../../delivery-nova-poshta/index.vue";
// import DatePicker from 'vue2-datepicker';
// import 'vue2-datepicker/index.css';
import VueFlatPickr from "vue-flatpickr-component";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";
import { VueSlideToggle } from "vue-slide-toggle";
import mainSelect from "@/components/main-select/index.vue";

export default {
    name: "type-delivery",
    mixin: [validationMixin],
    data() {
        return {
            currentTime: null,
            currentDay: null,
            payload: {
                city: "",
                street: "",
                house: "",
                flat: "",
                delivery: "",
                dateDelivery: "",
                timeDelivery: "",
                affiliate_id: "",
            },
            configDate: {
                locale: Ukrainian,
                dateFormat: "Y-m-d",
                disable: [
                    function(date) {
                        return date.getDay() === 0 || date.getDay() === 7;
                    },
                ],
            },
            configTime: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
            },
            newConfig: {
                minDate:
                    moment().hour() > 13
                        ? moment()
                              .add(1, "days")
                              .toDate()
                        : moment().toDate(),
            },
            dateDeliverySelector: false,
            validationErrors: {},
            valid: false,
        };
    },
    validations() {
        if (this.payload.delivery.id === 2) {
            return {
                payload: {
                    city: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    street: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    house: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(9),
                    },
                    flat: {
                        minLength: minLength(1),
                        maxLength: maxLength(9),
                    },
                },
            };
        } else if (this.payload.delivery.id === 1) {
            return {
                payload: {
                    city: {
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    street: {
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    house: {
                        minLength: minLength(1),
                        maxLength: maxLength(9),
                    },
                    flat: {
                        minLength: minLength(1),
                        maxLength: maxLength(9),
                    },
                },
            };
        } else {
            return {
                payload: {
                    city: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    street: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(50),
                    },
                    house: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(9),
                    },
                    flat: {
                        minLength: minLength(1),
                        maxLength: maxLength(9),
                    },
                },
            };
        }
    },
    created() {
        let time = new Date();
        this.currentTime = time.getHours();
        this.currentDay = time.getDate();
        if (this.user) {
            this.setAuthData();
        } else {
            this.setuserData();
        }
        if (this.isAuthenticated && this.user.agent_status) {
            this.setClientData();
        }
        if (!this.deliveryMethodsList) {
            this.fetchDeliveryList(this.payload.delivery).then(() => {
                // this.payload.delivery = this.deliveryMethodsList.methods[0];
            });
        } else {
            // this.payload.delivery = this.deliveryMethodsList.methods[0];
        }
    },
    components: {
        deliveryNovaPoshta,
        "date-picker": VueFlatPickr,
        VueSlideToggle,
        mainSelect,
    },
    computed: {
        ...mapGetters({
            isAuthenticated: `auth/isAuthenticated`,
            agentClients: "profile/agentClients",
            userInfo: "order/userInfo",
            deliveryMethodsList: "deliveryMethods/deliveryMethodsList",
            deliveryMethodsListLoading: "deliveryMethods/deliveryMethodsListLoading",
            user: "profile/user",
            getFilial: `deliveryMethods/getFilialList`,
            towns: "order/towns",
            addressData: "order/address",
            departments: "order/departments",

        }),
        getCurrentFilial() {
            let filial = JSON.parse(localStorage.getItem("branchId"));
            return this.$t("cityPrefix") + ". " + (filial?.city_name || 'Кременчук') + ", " + (filial?.street || 'вул. Лікаря Богаєвського, 29');
        },
        getCurrentTime() {
            let filial = JSON.parse(localStorage.getItem("branchId"));
            return (filial?.schedule || "З 09:00 До 18:00");
        },
        config() {
            return Object.assign({}, this.configDate, this.newConfig);
        },
        getTimeDelivery() {
            return this.deliveryMethodsListLoading;
        },

        timeList() {
            if (this.payload.dateDelivery.slice(-2) === this.currentDay.toString()) {
                return [`${this.$t("from13To16")}`];
            } else {
                return [`${this.$t("from9To13")}`, `${this.$t("from13To16")}`];
            }
        },

        cityErrors() {
            let error = [];
            if (!this.$v.payload.city.$dirty) {
                return error;
            }
            if (!this.$v.payload.city.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.city.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.city.minLength) {
                error.push(this.$t("validationMin").replace(":count", 3));
            }
            if (this.validationErrors.city) {
                this.validationErrors.city.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        streetErrors() {
            let error = [];
            if (!this.$v.payload.street.$dirty) {
                return error;
            }
            if (!this.$v.payload.street.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.street.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.street.minLength) {
                error.push(this.$t("validationMin").replace(":count", 3));
            }
            if (this.validationErrors.street) {
                this.validationErrors.street.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        houseErrors() {
            let error = [];
            if (!this.$v.payload.house.$dirty) {
                return error;
            }
            if (!this.$v.payload.house.maxLength) {
                error.push(this.$t("validationMax") + " 6");
            }
            if (!this.$v.payload.house.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.house.minLength) {
                error.push(this.$t("validationMin").replace(":count", 1));
            }
            if (this.validationErrors.house) {
                this.validationErrors.house.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        flatErrors() {
            let error = [];
            if (!this.$v.payload.flat.$dirty) {
                return error;
            }
            if (!this.$v.payload.flat.maxLength) {
                error.push(this.$t("validationMax") + " 6");
            }
            if (!this.$v.payload.flat.minLength) {
                error.push(this.$t("validationMin") + " 6");
            }
            if (this.validationErrors.flat) {
                this.validationErrors.flat.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapMutations({
            changeUserInfo: "order/CHANGE_USER_INFO",
            changeStep: "order/CHANGE_STEP_BUY_FLOW",
            backStep: "order/BACK_STEP_BUY_FLOW",
        }),
        ...mapActions({
            fetchDeliveryList: `deliveryMethods/GET_DELIVERY_METHODS_LIST`,
            fetchPaymentList: `paymentMethods/GET_PAYMENT_METHODS_LIST`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.validationErrors.length || this.payload.delivery === 1) {
                for (let key in this.payload.affiliate_id) {
                    if (key === "id") {
                        this.payload.affiliate_id = this.payload.affiliate_id[key];
                    }
                }
                this.changeUserInfo(this.payload);
                this.changeStep();
            }
        },
        setuserData() {
            this.payload.city = this.userInfo.city;
            this.payload.street = this.userInfo.street;
            this.payload.house = this.userInfo.house;
            this.payload.flat = this.userInfo.flat;
        },
        setAuthData() {
            let mainAddress = this.user.addresses.find(main => main.active === 1);
            if (mainAddress) {
                this.payload.city = mainAddress.city;
                this.payload.street = mainAddress.street;
                this.payload.house = mainAddress.house;
                this.payload.flat = mainAddress.flat;
            }
        },
        setClientData() {
            this.payload.city = this.userInfo.city;
            this.payload.street = this.userInfo.street;
            this.payload.house = this.userInfo.house;
            this.payload.flat = this.userInfo.flat;
        },
    },
};
